import { PlayerCardsContextData } from "./PlayerCardsContext";
import { UserContextData } from "./UserContext";
import { Blog, PlayerCardWidget } from "@/services/bedrock";
import { createInitialRecordContextData, createRecordContextData, RecordContextData } from "./RecordContext";
import { useBlogSearch } from "@/utils/useBlogSearch";
import { useCallback } from "react";

export interface BlogContextData extends RecordContextData<Blog> {}

export const InitialBlogContextData: BlogContextData = createInitialRecordContextData<Blog>();

export const BlogContext = (PlayerCards: PlayerCardsContextData, User: UserContextData): BlogContextData => {
  const { fetchBlogs } = useBlogSearch();
  const fetchPage = useCallback(
    (playerId: number, page: number, perPage: number, search?: string) => {
      // Only published Blogs can be surfaced on a Player Card.
      return fetchBlogs({
        playerId,
        search,
        page,
        perPage,
        status: "PUBLISHED",
        sort: "published_at",
        order: "desc",
      });
    },
    [fetchBlogs]
  );
  const getRecordFromWidget = (w: PlayerCardWidget): Blog | null => {
    return w.owner?.type === "Blog" ? w.owner.blog ?? null : null;
  };
  const isRecordNewer = (record: Blog, otherRecord?: Blog) => {
    if (!otherRecord) return true;
    return record.createdDate > otherRecord.createdDate;
  };

  return createRecordContextData<Blog>(PlayerCards, User, "Blog", fetchPage, getRecordFromWidget, isRecordNewer);
};
